// extracted by mini-css-extract-plugin
module.exports = {"waterMark":"watermark_waterMark__1nOrE"};